import React from 'react';
import { Link } from 'react-router';
import { Nav, Title, Subtitle } from '../static/new-new/FullLanding';

import '../static/new-new/NewStyle.scss';

const EmptyPage = () => (
  <div className="container-fluid new-style code-gray-bg empty-page">
    <Nav />

    <div className="row text-center">
      <Title>OOOPS...404! </Title>

      <Subtitle>Страница не найдена :( </Subtitle>
      <Link to="/">Вернуться на главную</Link>
    </div>
  </div>
);

export default EmptyPage;
